import Gauge from '@/components/Gauge';

import { Text } from '@simplywallst/ui-core';

import { formatterPercentage } from '@/utilities/format';

import { Card } from '../Card';

export interface Props {
  portfolioValue: number | null;
  marketValue: number | null;
}

export const ReturnOnEquity = ({ portfolioValue, marketValue }: Props) => {
  return (
    <Card
      title="Return on Equity"
      description={
        <Text color="inherit" typography="xSmall">
          This chart presents a comparison of the Portfolio's Return on Equity
          (ROE) with that of the broader marke. ROE, a crucial financial metric,
          measures a company's ability to generate profits from its
          shareholders' equity, effectively showing how efficiently equity is
          being used to produce earnings. This direct comparison of your
          portfolio ROE vs market aids in evaluating the efficiency of the
          portfolio in generating profits relative to the market standard. A
          higher ROE indicates a more efficient use of equity in generating
          profits, while a lower ROE may suggest the opposite. Use this
          comparison to gauge the relative financial performance and efficiency
          of your portfolio compared to the broader market, assisting in
          strategic investment decision-making.{' '}
          <a
            href="https://support.simplywall.st/hc/en-us/articles/9423775242383-Understanding-the-New-Portfolio-Analysis-Calculations"
            rel="noreferrer nofollow"
            target="_blank"
          >
            Learn more
          </a>
        </Text>
      }
    >
      <Gauge
        keys={['portfolio', 'market']}
        entities={{
          portfolio: portfolioValue,
          market: marketValue,
        }}
        numTicks={5}
        title="ROE Ratio"
        from={0}
        to={0.4}
        formatter={formatterPercentage}
      />
    </Card>
  );
};
